import script from "./unsubmitMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./unsubmitMessage.vue?vue&type=script&setup=true&lang=js"

import "./unsubmitMessage.vue?vue&type=style&index=0&id=2c498d98&lang=scss"

const __exports__ = script;

export default __exports__